import React from "react";
import styled from "styled-components/macro";
import finishModal2 from "../../../images/unitPopup/finishModal2.svg";

const FinishModalStep2 = () => {
  return (
    <div>
      <div style={{ padding: "90px" }}>
        <Title style={{ textTransform: "uppercase", fontWeight: "bolder" }}>
          Thanks for reaching out!
        </Title>
        <Title
          style={{
            color: "#707070",
            fontSize: "20px",
            marginTop: "20px",
          }}
        >{`A representative on our behalf will contact you shortly.\nSoon, you'll have your own 24/7 TULU Unit in the building for daily use!`}</Title>
        <Img src={finishModal2} />
        <Title
          style={{
            textTransform: "uppercase",
            color: "#4b4b4b",
            fontSize: "20px",
            marginTop: "20px",
          }}
        >{`A leapfrog in comfort and accessibility.\nA new standard for urban life.`}</Title>
      </div>
      {/*<div*/}
      {/*  style={{ width: "100%", alignItems: "center", justifyContent: "center", display: "flex", margin: "30px 0" }}>*/}
      {/*  <StyledBlackButton onClick={() => onPress()}>Get a quote</StyledBlackButton>*/}
      {/*</div>*/}
    </div>
  );
};

export { FinishModalStep2 };

const Title = styled.div`
  color: #4b4b4b;
  font-size: 31px;
  font-family: Manrope, serif;
  line-height: 1.5;
  text-align: center;
  white-space: pre-wrap;
`;
const Img = styled.img`
  object-fit: contain;
  margin: 42px;
`;
